import { render } from "./BuyFormPage.vue?vue&type=template&id=1bf02d14"
import script from "./BuyFormPage.vue?vue&type=script&lang=js"
export * from "./BuyFormPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__